import { UserAuthFormData } from '@/components/auth-page/user-auth-form'
import { Icons } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { useGoogleLoginMutation } from '@/src/mutations/auth/google-login'
import { useGoogleLogin } from '@react-oauth/google'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { UseFormSetError } from 'react-hook-form'
import { toast } from 'sonner'
import { usePostHogEvents, EVENTS } from '@/lib/posthog-events'

export default function GoogleLoginRedirection({
  setError,
}: {
  setError: UseFormSetError<UserAuthFormData>
}) {
  const googleMutation = useGoogleLoginMutation()
  const { trackEvent } = usePostHogEvents()
  const searchParams = useSearchParams()
  let tokenResponse = searchParams?.get('code')
  const [currentURL, setCurrentURL] = useState<string>('');
  useEffect(() => {
    setCurrentURL(window.location.origin+window.location.pathname);
  }, []);
  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect', // Set UX mode to 'redirect'
    redirect_uri: currentURL, // Replace with your redirect URI
    onSuccess: codeResponse => console.log(codeResponse, "tokenResponse"),
    onError: () => {
      toast.error('Error while logging in with Google')
      setError('root', {
        type: 'manual',
        message: 'Error while logging in with Google',
      })
    },
    onNonOAuthError: (error) => {
      if (error.type !== 'popup_closed') {
        toast.error('Error while logging in with Google')
        setError('root', {
          type: 'manual',
          message: 'Error while logging in with Google',
        })
      }
    },

  })
  const loginGoogle = async () => {
    tokenResponse && await googleMutation.mutate(
      { googleCode: tokenResponse, redirUrl: currentURL },
      {
        onSuccess() {
          toast.success('Logged in with Google!')
          trackEvent(EVENTS.USER_LOGGED_IN, { provider: 'google', method: 'oauth', flow: 'redirect' })
          // router.push('/home')
        },
        onError(error) {
          setError('root', {
            type: 'manual',
            message: error.message,
          })
          toast.error(error.message)
        },
      }
    )
  }

  const [hasLoggedIn, setHasLoggedIn] = useState(false);

  useEffect(() => {
    if (tokenResponse && !hasLoggedIn&&currentURL) {
      loginGoogle();
      setHasLoggedIn(true);
    }
  }, [tokenResponse, hasLoggedIn,currentURL]);

console.log(currentURL,"currentURL")
  return (
    <>
      <Button
        className="font-base flex-1 border border-gray bg-white text-black hover:bg-lightergray "
        onClick={(e) => {
          e.preventDefault()
          googleLogin()
        }}
        isLoading={googleMutation.isPending}
      >
        <Icons.google className="mr-2 h-4 w-4" />
        Continue with Google
      </Button>
    </>
  )
}